import React from "react";
import "./codingprofile.css";
import Button from "@mui/material/Button";
import SendIcon from "@mui/icons-material/Send";
import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Tilt from "react-parallax-tilt";

function Codingprofile() {
  function handleDelete() {}
  let navigate = useNavigate();
  return (
    <div className="coding-profile-section">
      <Typography
        variant="h4"
        component="div"
        align="center"
        sx={{
          color: "#fff",
          margin: "30px 0px",
        }}>
        Let's Do some code...
      </Typography>

      <Tilt tiltEnable={false} scale={1.2} transitionSpeed={2500}>
        <section className="window">
          <div className="window-top">
            <div className="window__controls">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <div className="window__title">CodingProfile.cpp</div>
            <Button
              color="warning"
              variant="contained"
              endIcon={<SendIcon />}
              size="small"
              onClick={() => {
                navigate("/dsa-profile");
              }}>
              Run
            </Button>
          </div>

          <div className="window-main">
            <ol>
              <li>
                <span className="text">#include</span> &lt;
                <span className="tag">bits/stdc++.h</span>&gt;
              </li>
              <li>
                <span className="text">using namespace std;</span>
              </li>
              <li>
                <br></br>
              </li>
              <li>
                <span className="comment">// Run the code....</span>
              </li>
              <li>
                <br></br>
              </li>
              <li>
                <span className="tag">int main() &#123; </span>
              </li>
              <li>
                <br></br>
              </li>
              <li> &nbsp;&nbsp;&nbsp;&nbsp; // Code starts from here</li>
              <li>
                &nbsp;&nbsp;&nbsp;&nbsp;<span className="tag">cout</span>
                &nbsp;&lt;&lt;
                <span className="text">
                  &nbsp; "Let's have a look at my DSA profile!!"
                </span>
              </li>
              <li>
                <br></br>
              </li>
              <li>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <span className="tag">if( isFetching ) &#123; </span>
              </li>
              <li>
                &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;
                <span className="tag">cout </span>&nbsp;&lt;&lt;
                <span className="text">&nbsp; "Loading...";</span>
              </li>
              <li>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <span className="tag">} else &#123;</span>
              </li>
              <li>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span className="tag">cout </span>&nbsp;&lt;&lt;
                <span className="text">&nbsp; Display_DSAProfile();</span>
              </li>
              <li>
                &nbsp;&nbsp;&nbsp;&nbsp;<span className="tag">}</span>
              </li>
              <li>
                <br></br>
              </li>
              <li>
                &nbsp;&nbsp;&nbsp;&nbsp;<span className="tag">return 0;</span>
              </li>
              <li>
                <br></br>
              </li>
              <li>
                <span className="tag">}</span>
              </li>
            </ol>
          </div>
        </section>
      </Tilt>
    </div>
  );
}

export default Codingprofile;
